module.exports = __webpack_public_path__ + "img/corona-fleischindustrie.7ccad6b8.png";